import React, { useState, useEffect } from 'react'
import i18n from '@dhis2/d2-i18n'
import classes from '../../App.module.css'
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { apiServices } from '../../services/apiServices'
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from "@material-ui/core/Button";
import { Select, MenuItem, FormControl, InputLabel, Box } from '@material-ui/core';
// import { TextField } from '@material-ui/core';
// import {Autocomplete } from 'mui-rff';
import { CircularLoader, CenteredContent } from '@dhis2/ui';
import swal from 'sweetalert';
import { useTranslation } from 'react-i18next';
import OfflineDb from '../../db'
import DateFnsUtils from '@date-io/date-fns';
import {useGlobalSpinnerActionsContext} from '../../context/GlobalSpinnerContext'
import SearchBar from '../../component/searchbar/SearchBar';
//import {Configuration} from '../../assets/data/config'
import _ from 'lodash';
import { useHistory, useLocation } from "react-router";
import '../../assets/css/customstyles.css'
import '../../assets/css/theme_grey.css'
import '../../assets/css/theme_blue.css'
import '../../assets/css/theme_green.css'
import '../../assets/css/theme_red.css'
import AccordianList from '../../component/contentList/AccordianList'
import CardList from '../../component/contentList/CardList'
import Pagination from "@material-ui/lab/Pagination";
import moment from 'moment'
import FooterMenu from '../../component/layout/FooterMenu';
import { addDays, subDays, format } from 'date-fns';
import {
    TextFi,
    DatePicker,
    Checkboxes,
    CheckboxData,
    Radios,
    TimePicker,
    Switches,
    KeyboardDatePicker,
    DateTimePicker,
    Autocomplete,
} from "mui-rff";
import {
    SingleSelectFieldFF,
    ReactFinalForm,
    InputFieldFF
} from '@dhis2/ui';
import { TextField } from '@material-ui/core';
import { parseISO } from 'date-fns';

const defaultDate = new Date().toISOString()
const { Form, FormSpy } = ReactFinalForm



function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: 'transparent',
        display: 'flex',
        justifyContent: 'center',
        marginTop: '30px',
    },
}));


// component start here
const ReferralCases = () => {
    const { t } = useTranslation();
    const localClasses = useStyles();
    const location = useLocation();
    const [sessionUserBoValue, setSessionUserBoValue] = React.useState(null)
    const [progarmData, setProgarmData] = useState(null)
    const history = useHistory();
    const [Configuration,setConfiguration] = useState(null);
    const [referralList, setReferralList] = useState(null);
    const [tabPanelValue, setTabPanelValue] = useState(0);
    const [viewType, setViweType] = useState('list')
    const setGlobalSpinner = useGlobalSpinnerActionsContext()
    const [input, setInput] = useState('');
    const [searchAllResult,setSearchAllResult] = useState([])
    const [userRole,setUserRole] = useState(null)
    const [page, setPage] = useState(1);
    const [noOfPages,setNoOfPages] = useState(0)
    const [yearOptions, setYearOptions] = useState([]);
    const [yearValue, setYearValue] = useState(moment().year());
    const [noOfRecordValue, setNoOfRecordValue] = useState(50);
    const [referralType, setReferralType] = useState(null);
    const [referralTabs, setReferralTabs] = useState([]);
    const [startdate, setstartDate] = useState(null);
    const [enddate, setenddate] = useState(null);
    const currentYear = moment().year();
    //const currentYear = moment().year();
    // constants for labels by uid
    const listOfFields = progarmData != null ? progarmData.programs[0].programTrackedEntityAttributes : [];
    const fieldsToDisplay = listOfFields.filter(obj => obj.displayInList == true)

    async function getMetaData() {
        let metadata = await OfflineDb.getDataFromPouchDB('metaData')
        setProgarmData(metadata.data)

        let loginDetails = await OfflineDb.getDataFromPouchDB('loginDetails')
        setSessionUserBoValue(loginDetails.data)

        let configurations = await OfflineDb.getDataFromPouchDB('configurations')
        setConfiguration(configurations.data.configuration)
    }
    useEffect(() => {
        getMetaData()
        if(localStorage.getItem("localstartdate")){
            localStorage.removeItem("localstartdate")
        }
        if(localStorage.getItem("localenddate")){
            localStorage.removeItem("localenddate")
        }
    }, [])

    useEffect(() => {
        try{
            let yearVal = []
            for(let i = 2021; i <= currentYear; i++){
                yearVal.push(i)
            }
            setYearOptions(yearVal.reverse())
         }catch(e){}
    },[])

    useEffect(()=>{
        if(referralList != null && Configuration != null && Object.keys(referralList)){   
            try{
                setNoOfPages(Math.ceil(referralList[Object.keys(referralList)[tabPanelValue]].length / Configuration.pagination.itemsPerPage))
            }catch(e){

            }
        }
    },[referralList,Configuration,tabPanelValue])

    //default dates 
        // const currentDate = new Date();
        // const date15DaysAgo = subDays(currentDate, 30);

        let defaultend = new Date(); 
        let defaultstart = subDays(defaultend, 30);
        //console.log("startDate",startDate,endDate)

        let startDate = new Date(defaultstart)
        let year = startDate.getFullYear().toString(); // Get last two digits of the year
        let month = ('0' + (startDate.getMonth() + 1)).slice(-2); // Months are zero-based, so add 1 and pad with zero if needed
        let day = ('0' + startDate.getDate()).slice(-2); // Pad day with zero if needed

        let defaultformattedstartdate =  `${year}-${month}-${day}`;

        let endDate = new Date(defaultend)
        let endyear = endDate.getFullYear().toString(); // Get last two digits of the year
        let endmonth = ('0' + (endDate.getMonth() + 1)).slice(-2); // Months are zero-based, so add 1 and pad with zero if needed
        let endday = ('0' + endDate.getDate()).slice(-2); // Pad day with zero if needed

        let defaultformattedenddate =  `${endyear}-${endmonth}-${endday}`;
        const localStartDate = localStorage.getItem('localstartdate');
        const localEnddate = localStorage.getItem('localenddate');

    useEffect(() => {
        if(sessionUserBoValue != null){
            console.log("sessionUserBoValue.userRoles[0].name",sessionUserBoValue,sessionUserBoValue.userRoles[0])

            if(sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && sessionUserBoValue.userRoles[0].name == 'ART user'){
                setReferralTabs({
                    "ART CLINIC" :[]
                })
            }else if(sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && sessionUserBoValue.userRoles[0].name == 'HTC'){
                setReferralTabs({
                    "HTC CLINIC" : []
                })

            }else if(sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && sessionUserBoValue.userRoles[0].name == 'ART-I user'){
                console.log("sessionUserBoValue.userRoles[0].name",sessionUserBoValue.userRoles[0].name)
                setReferralTabs({
                    "ART INITIATION" : []
                })
            }else{
                setReferralTabs({
                    "HTC CLINIC" : [],
                    "ART CLINIC" :[],
                    "ART INITIATION" : []
                })
            }

            if(sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles.length > 1){
                const hasArtIUser = sessionUserBoValue.userRoles.some(item => item.name === "ART-I user");
                setReferralTabs({
                    "HTC CLINIC" : [],
                    "ART CLINIC" :[],
                    "ART INITIATION" : []
                })
                if(!hasArtIUser){
                    setReferralTabs({
                        "HTC CLINIC" : [],
                        "ART CLINIC" :[]
                    })
                }
            }
        }
    },[sessionUserBoValue])

    useEffect(() => {

        if(sessionUserBoValue != null && progarmData != null){
            let type = "HTC CLINIC"
            if(sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && sessionUserBoValue.userRoles[0].name == 'ART user'){
                type = "ART CLINIC"
            }else if(sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && sessionUserBoValue.userRoles[0].name == 'ART-I user'){
                type = "ART INITIATION"
            }else if(sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && sessionUserBoValue.userRoles[0].name == 'HTC'){
                type = "HTC CLINIC"
            }
            if(sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles.length > 1){
                    const hasHTCUser = sessionUserBoValue.userRoles.some(item => item.name === "HTC");
                    if(hasHTCUser){
                        type = "HTC CLINIC"
                    }
            }

            const searchParams = new URLSearchParams(location.search);
            let tabval = searchParams.size != 0 ? searchParams.get('newValue') : 0

            if(tabval && tabval == 1) {
                type = "ART CLINIC"
            }

            if(tabval && tabval == 2) {
                type = "ART INITIATION"
            }

            getReferralList(type)
        }
    
        setstartDate(!localStorage.getItem("localstartdate") ? defaultformattedstartdate : localStorage.getItem("localstartdate"))
        setenddate(!localStorage.getItem("localenddate") ? defaultformattedenddate : localStorage.getItem("localenddate"))
        // if (localStorage.getItem("localstartdate") && localStorage.getItem("localenddate")) {
        //         localStorage.removeItem('localstartdate');
        //         localStorage.removeItem('localenddate');
        // }

      

    }, [sessionUserBoValue, progarmData, startdate, enddate, ]) //noOfRecordValue

    const getReferralList  = (type) =>{
        try{
            if(localStorage.getItem('referral-type')){
                localStorage.removeItem('referral-type')
            }
            if(!type){
                type = "HTC CLINIC"
            }
    
            if (sessionUserBoValue != null && progarmData != null) {
                const allOU = sessionUserBoValue ? sessionUserBoValue ? sessionUserBoValue.organisationUnits : sessionUserBoValue.organisationUnits[0].id : sessionUserBoValue.organisationUnits[0].id;
            let hotspots = null;
            if(allOU){
                //allOU = _.filter(allOU,{"level":6})
                allOU.map((hotspot, i) => {
                    //if(hotspot["level"] && hotspot["level"] == 6){
                        if(hotspots){
                            hotspots = hotspots+';'+hotspot.id
                        }else{
                            hotspots = hotspot.id
                        }
                        
                    //}
                })
            }
            setGlobalSpinner(true)
            let OU = hotspots ? hotspots : sessionUserBoValue.organisationUnits[0].id
                const subURL = `referral/list?ouid=${OU}&programid=${sessionUserBoValue.programs[0]}&pageSize=50&skipPaging=true&paging=true&type=${type}&startdate=${startdate}&enddate=${enddate}`;
                apiServices.getAPI(subURL).then(response => {
                    console.log("response.data.data",response)
                    if(_.isEmpty(response.data.data)) {
                        console.log("response.data.data",response)
                        swal({
                            text: t("No records found for this date range"),
                            icon: "warning",
                            button: t("Close"),
                        })
                        // .then(res => {
                        //     if(res) {
                        //         //history.push('/layout/home')
                        //     }
                        // })
                        setReferralList(response.data.data);
                    }else {
                    let resData = _.cloneDeep(response.data.data)                    
                    let artData = _.filter(resData,{"type" : "ART CLINIC"})
                    let htcData = _.filter(resData,{"type" : "HTC CLINIC"})
                    let artIData = _.filter(resData,{"type" : "ART INITIATION"})
                    if(artData && artData.length > 0){
                        resData["ART CLINIC"] = artData
                    }
                    if(htcData && htcData.length > 0){
                        resData["HTC CLINIC"] = htcData
                    }
                    if(artIData && artIData.length>0){
                        resData["ART INITIATION"] = artIData
                    }
                    let filterRefer = {};
                    if(sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && sessionUserBoValue.userRoles[0].name == 'ART user' && sessionUserBoValue.userRoles.length == 1){
                        filterRefer["ART CLINIC"] = resData ? resData["ART CLINIC"] ? resData["ART CLINIC"] : [] : [] 
                        console.log("resData[ART CLINIC]")
                        setUserRole(sessionUserBoValue.userRoles[0].name);
                    }else if(sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && sessionUserBoValue.userRoles[0].name == 'HTC' && sessionUserBoValue.userRoles.length == 1){
                        filterRefer["HTC CLINIC"] = resData ? resData["HTC CLINIC"] ? resData["HTC CLINIC"] : [] : [] 
                        setUserRole(sessionUserBoValue.userRoles[0].name);
                    }else if(sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name && sessionUserBoValue.userRoles[0].name == 'ART-I user' && sessionUserBoValue.userRoles.length == 1){
                        filterRefer["ART INITIATION"] = resData ? resData["ART INITIATION"] ? resData["ART INITIATION"] : [] : [] 
                        setUserRole(sessionUserBoValue.userRoles[0].name);
                    }else{
                        //filterRefer = resData
                        filterRefer = {
                            "HTC CLINIC" : [],
                            "ART CLINIC" : [],
                            "ART INITIATION" : []
                        }
                        if(resData &&  resData["HTC CLINIC"]){
                            filterRefer["HTC CLINIC"] = resData ? resData["HTC CLINIC"] ? resData["HTC CLINIC"] : [] : [] 
                            if(sessionUserBoValue.userRoles[0].name == "Supervisor user" || sessionUserBoValue.userRoles.length > 1){
                                filterRefer["ART CLINIC"] = []
                            }
                        }
                        if(resData &&  resData["ART CLINIC"]){
                            if(sessionUserBoValue.userRoles[0].name == "Supervisor user" || sessionUserBoValue.userRoles.length > 1){
                                filterRefer["HTC CLINIC"] = []
                            }
                            filterRefer["ART CLINIC"] = resData ? resData["ART CLINIC"] ? resData["ART CLINIC"] : [] : []
 
                        }
                        if(resData &&  resData["ART INITIATION"]){
                            if(sessionUserBoValue.userRoles[0].name == "Supervisor user" || sessionUserBoValue.userRoles.length > 1){
                                filterRefer["HTC CLINIC"] = []
                            }
                            filterRefer["ART INITIATION"] = resData ? resData["ART INITIATION"] ? resData["ART INITIATION"] : [] : [] 
 
                        }
                        if(Object(filterRefer).length == 0){
                            filterRefer = resData;
                        }
                        if(sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles[0].name){
                            setUserRole(sessionUserBoValue.userRoles[0].name);
                        }
                    }

                    if(sessionUserBoValue && sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles.length > 1){
                        let artRole = false;
                        let htcRole = false;
                        let artiRole = false
                        sessionUserBoValue.userRoles.map(function(data, j) {
                            if(data["name"] == 'ART user'){
                                artRole = true;
                            }
                            if(data["name"] == 'HTC'){
                                htcRole = true;
                            }
                            if(data["name"] == 'ART-I user'){
                                artiRole = true;
                            }
                        })
                        if((artRole || artiRole) && htcRole){
                            //filterRefer = resData;
                            if(resData &&  resData["HTC CLINIC"]){
                                filterRefer["HTC CLINIC"] = resData ? resData["HTC CLINIC"] ? resData["HTC CLINIC"] : [] : [] 
                                filterRefer["ART CLINIC"] = []
                            }
                            if(resData &&  resData["ART CLINIC"]){
                                filterRefer["HTC CLINIC"] = []
                                filterRefer["ART CLINIC"] = resData ? resData["ART CLINIC"] ? resData["ART CLINIC"] : [] : [] 
                            }
                            if(artiRole){
                                if(resData &&  resData["ART INITIATION"]){
                                    filterRefer["ART INITIATION"] = resData ? resData["ART INITIATION"] ? resData["ART INITIATION"] : [] : [] 
                                }
                            }
                            if(Object(filterRefer).length == 0){
                                filterRefer = resData;
                            }
                            setUserRole('HTCART');
                        }
                    }
                    //filterRefer = response.data.data
                    //console.log("filterRefer ",filterRefer)
                    setReferralList(filterRefer);
                    setSearchAllResult(filterRefer)
                    }
                    
                    setGlobalSpinner(false);
                }).catch(err => {
                    swal({
                        title: t("Error"),
                        text: t(err),
                        icon: "error",
                        button: t("Close"),
                    });
                    setGlobalSpinner(false);
                });
            }
        }catch(e){ 
            setGlobalSpinner(false)
            console.log(e)
        }
    }
    
    useEffect(()=>{
        try{
            if(location && location.search && page){
                let params = location.search.split('&')
                let pageNumber = params[0].split('=')
                //let year = params[1] ? params[1].split('=') : ''
                if(pageNumber && pageNumber.length > 0 && page != pageNumber[1]){
                    setPage(Number(pageNumber[1]))
                }
                // if(year && year.length > 0){
                //     setYearValue(Number(year[1]))
                // }
               }
               const searchParams = new URLSearchParams(location.search);
               let tabval = searchParams.size != 0 ? searchParams.get('newValue') : 0
               if(tabval)
               setTabPanelValue(parseInt(tabval))
              // setYearValue()
        }catch(e){
            console.log(e)
        }
    },[location])

    const handleChange = (event, newValue) => {
        console.log("newValue ",newValue)
        setTabPanelValue(newValue);
        if(userRole == "HTCART" || userRole == "Supervisor user" || userRole == "ART-I user"){
            if(newValue == 0){
                const searchParams = new URLSearchParams(location.search);
                searchParams.set('page', page > 1 ? 1 : page);
                //searchParams.set('year', yearValue);
                searchParams.set('newValue', newValue);
                history.push({
                    pathname: location.pathname,
                    search: `?${searchParams.toString()}`,
                });
                getReferralList("HTC CLINIC")
            }
            if(newValue == 1){
                const searchParams = new URLSearchParams(location.search);
                searchParams.set('page', page > 1 ? 1 : page);
                //searchParams.set('year', yearValue);
                searchParams.set('newValue', newValue);
                history.push({
                    pathname: location.pathname,
                    search: `?${searchParams.toString()}`,
                });
                getReferralList("ART CLINIC")
            }
            if(userRole == "ART-I user" || newValue == 2){
                const searchParams = new URLSearchParams(location.search);
                searchParams.set('page', page > 1 ? 1 : page);
                //searchParams.set('year', yearValue);
                searchParams.set('newValue', newValue);
                history.push({
                    pathname: location.pathname,
                    search: `?${searchParams.toString()}`,
                });
                getReferralList("ART INITIATION")
            }
        }
        //getReferralList(type)
        try{
            setPage(1);
            setNoOfPages(Math.ceil(referralList[Object.keys(referralList)[newValue]].length / Configuration.pagination.itemsPerPage))
        }catch(e){

        }
    };
    const handlePageChange = (event, value) => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('page', value);
        //searchParams.set('year', yearValue);
        history.push({
            pathname: location.pathname,
            search: `?${searchParams.toString()}`,
          });
        setPage(value);
    }
    const updateInput = (input) => {
        setInput(input);
        let filteredList = {}
        setGlobalSpinner(true)
        if(input && input.length >= 3){
            
            Object.entries(searchAllResult).map(([key, val], idx) => {
                filteredList[key]=[];
                val.map(function(data, j) {
                    if(data[Configuration.searchbarfielduid] && data[Configuration.searchbarfielduid].toLowerCase().indexOf(input.toLowerCase()) > -1){
                        filteredList[key].push(data)
                    }
                })
            })
            setReferralList(null);
            setTimeout(function(){
                setGlobalSpinner(false)
                setReferralList(filteredList)
            },500)
        }else{
            if(input.length == 0){
                setReferralList(null);
                setTimeout(function(){
                    setGlobalSpinner(false)
                    setReferralList(searchAllResult)
                },1000)
                
            }else{
                setGlobalSpinner(false)
            }
        }
    }
    const renderRefferalCard = (props) => {
        
        const labelsArr = [];
        fieldsToDisplay.forEach((item) => {
            let obj = {};
            if (props.hasOwnProperty(item.trackedEntityAttribute.id)) {
                obj[item.trackedEntityAttribute.displayName] = props[item.trackedEntityAttribute.id];
                labelsArr.push(obj);
            }
        })
        if(userRole){
            props["userRole"] = userRole
        }
        return (
            viewType == 'card'
          ?
          <CardList AccordionLabel = {labelsArr.find(x => x["Nick Name"]) ? labelsArr.find(x => x["Nick Name"])['Nick Name'] : ''} AccordionContent = {<></>} AccordionDataObject = {labelsArr} TrackEntityId = {props.instanceid} Component={'Referal'} PropsArray = {props}/>
          
          :
          <AccordianList AccordionLabel = {labelsArr.find(x => x["Nick Name"]) ? labelsArr.find(x => x["Nick Name"])['Nick Name'] : ''} AccordionContent = {<> </>} AccordionDataObject = {labelsArr} TrackEntityId = {props.instanceid} Component={'Referal'} PropsArray = {props}/>
        );
    }
    function UpdateRecordClick(instanceid) {
        setGlobalSpinner(true)
        const activeCaseDetails = {
          'trackedEntityInstance': instanceid,
          'enrollmentId': "",
        }
        const linkContact = {
          "enabled": false,
          "linkTrackedEntityInstance": instanceid
        }
        OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
        OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)
        setGlobalSpinner(false)
        history.push('/layout/registration')
    }
    const handleViewChange = (event,newValue) => {
        setViweType(newValue);
    };
    const getMonthwiseReport = (value) => {
        //debugger
        let start = value.Datefrom ;
        let end = value.DateTo ; 
        let orwid = value ? value.orw : '';//data["month"];
        //console.log("startDate",startDate,endDate)

        let startDate = new Date(start)
        let year = startDate.getFullYear().toString(); // Get last two digits of the year
        let month = ('0' + (startDate.getMonth() + 1)).slice(-2); // Months are zero-based, so add 1 and pad with zero if needed
        let day = ('0' + startDate.getDate()).slice(-2); // Pad day with zero if needed

        let formattedstartdate =  `${year}-${month}-${day}`;
        console.log("formattedstartdate",formattedstartdate)

        let endDate = new Date(end)
        let endyear = endDate.getFullYear().toString(); // Get last two digits of the year
        let endmonth = ('0' + (endDate.getMonth() + 1)).slice(-2); // Months are zero-based, so add 1 and pad with zero if needed
        let endday = ('0' + endDate.getDate()).slice(-2); // Pad day with zero if needed

        let formattedenddate =  `${endyear}-${endmonth}-${endday}`;
        setstartDate(formattedstartdate)
        setenddate(formattedenddate)
        setPage(1)
        localStorage.setItem("localstartdate",formattedstartdate)
        localStorage.setItem("localenddate", formattedenddate)       
        // console.log("localStorage.setItem",localStorage.getItem("localstartdate"))
        // if (startDate>endDate){
        //     swal({
        //                 title: t("Error"),
        //                 text: t("Date from should be greater than Date to"),
        //                 icon: "error",
        //                 buttons: t('Close')
        //             })
        // }
    };
    const handleNoOfRecordChange = (event) => {
        setNoOfRecordValue(event.target.value);
        setPage(1)
    };
    const loadViewToggleButtons = ()=>{
        return (
            <div className=" customregistrationtabs regcasetabs ">
                <AppBar position="static">
                    <Tabs value={viewType} onChange={handleViewChange} className="bottom-referral-bar">
                        <Tab value="list" label={t('List View')}></Tab>
                        <Tab value="card" label= {t('Card View')}></Tab>
                    </Tabs>
                </AppBar>
            </div>
            
        )
    }
    const haldleSubmitAction = (values) => {
        console.log("values",values);
    }

    
    
    return (
        <div className={classes.container}>
            <main
                style={{
                    display: 'flex',
                    height: '100%',
                    width: '100%'
                }}
            >
                <section className="searchcustombg searchtabmaindiv referalcasespage"
                    style={{
                        backgroundColor: '#fff',
                        flexGrow: 1,
                        padding: 0,
                    }}
                >
                    <FooterMenu></FooterMenu>
                    {/* {loading ?
                        <CenteredContent dataTest="dhis2-uicore-centeredcontent" position="middle">
                            <CircularLoader large dataTest="dhis2-uicore-circularloader" />
                        </CenteredContent>
                        : ""
                    } */}
                    {/* {referralList != null ? loadViewToggleButtons() : null} */}
                <Grid container className="registration-page alerts_page">
                <Form
                onSubmit={(values) => haldleSubmitAction(values)}
                //intialValues={intialValues}
                initialValues={{ Datefrom: startdate, DateTo : enddate}}
                render={({ handleSubmit, form, submitting, pristine, values }) => (
                  <form id="target-search" onSubmit={handleSubmit} style={{width: '100%'}}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <DatePicker
                                  disabled={false}
                                  label={"Date from"}
                                  name={"Datefrom"}
                                  required={true}
                                 // value={!localStorage.getItem("localstartdate") ? defaultformattedstartdate : localStorage.getItem("localstartdate")}
                                 //value={localStorage.getItem("localstartdate") ?  localStorage.getItem("localstartdate") : ""}
                                  dateFunsUtils={DateFnsUtils}
                                  margin="normal"
                                  variant="inline"
                                  format={"yyyy-MM-dd"}
                                  //validate={composeValidators(required(values))}
                                  disableFuture={true}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <DatePicker
                                  disabled={false}
                                  label={"Date To"}
                                  name={"DateTo"}
                                  required={true}
                                  dateFunsUtils={DateFnsUtils}
                                  //value={!localStorage.getItem("localenddate") ? defaultformattedenddate : localStorage.getItem("localenddate")}
                                  //value={localStorage.getItem("localenddate") ? localStorage.getItem("localenddate") : ""}
                                  margin="normal"
                                  variant="inline"
                                  format={"yyyy-MM-dd"}
                                  validate={true}
                                  disableFuture={true}
                                  />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: '10px' }}>
                            <button style={{ float: 'right' }} className="regformsubmitbtn" type="button" onClick={() => getMonthwiseReport(values)}>
                                {t('Apply')}
                            </button>
                        </Grid>
                        </form>
                        )}
                    />
                            {/* <Form>
                                <InputLabel id="simple-select-label">{t("Years")}</InputLabel>
                                {console.log("yearValue",yearValue)}
                                <Select
                                labelId="simple-select-label"
                                id="simple-select"
                                value={yearValue}
                                label="Options"
                                onChange={handleYearChange}
                                >
                                    {
                                        yearOptions.map(ele => {
                                            return <MenuItem value={ele}>{ele}</MenuItem>
                                        })
                                    }
                                </Select>
                            </Form> */}
                </Grid>
                        <Grid item xs={4} md={2} lg={2}>
                            <FormControl fullWidth className='filter-box hide'>
                                <InputLabel id="simple-select-label">{t("Shows")}</InputLabel>
                                <Select
                                labelId="simple-select-label"
                                id="simple-select"
                                value={noOfRecordValue}
                                label="Options"
                                onChange={handleNoOfRecordChange}
                                >
                                    <MenuItem value={50}>{50}</MenuItem>
                                    <MenuItem value={100}>{100}</MenuItem>
                                    <MenuItem value={500}>{500}</MenuItem>
                                    <MenuItem value={1000}>{1000}</MenuItem>
                                    <MenuItem value={2000}>{2000}</MenuItem>
                                    <MenuItem value={3000}>{3000}</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    <Grid container spacing={3} className=" mb-30px">
                        <Grid item xs={12} sm={12} md={12} className="registration-page">
                            <SearchBar 
                                input={input} 
                                setKeyword={updateInput}
                            />
                            <div className=' customregistrationtabs regcasetabs taskListFooter'>
                                <AppBar position="static">
                                    <Tabs
                                        value={tabPanelValue}
                                        onChange={handleChange}
                                        variant="scrollable"
                                        scrollButtons="on"
                                        indicatorColor="primary"
                                        //textColor="primary"
                                        aria-label="scrollable force tabs example"
                                        className="bottom-referral-bar"
                                    >
                                        {referralTabs && Object.entries(referralTabs) && referralList != null ?
                                        Object.entries(referralTabs).map(([key, val], index) => {
                                            //console.log("key ",key,val,index,referralTabs)
                                            return (<Tab label={t(key)} {...a11yProps(index)} />)
                                        }):''}
                                    </Tabs>
                                </AppBar>
                            </div>
                        </Grid>
                        {/* {referralList != null ?
                        Object.entries(referralList).map(([key, val], idx) => {
                            return (
                                <TabPanel value={tabPanelValue} index={idx} className="regscrolltabs layoutscrolltabs referalscrolltabs margin-top-0">
                                    <Grid container spacing={3}>
                                        {
                                            val.map((item, index) => {
                                                return (renderRefferalCard(item, index))
                                            })
                                        }
                                    </Grid>
                                </TabPanel>
                            )
                        }):""} */}
                        {referralList != null  && page  && Configuration != null?
                        Object.entries(referralList)
                        .map(([key, val], idx) => {
                            return (
                                <TabPanel value={tabPanelValue} index={idx} className="regscrolltabs layoutscrolltabs referalscrolltabs margin-top-0">
                                    <Grid container spacing={3}>
                                        
                                        {
                                            val
                                            .slice((page - 1) * Configuration.pagination.itemsPerPage, page * Configuration.pagination.itemsPerPage)
                                            .map((item, index) => {
                                                return (renderRefferalCard(item, index))
                                            })
                                        }
                                    </Grid>
                                </TabPanel>
                            )
                        }):""}
                        <div style={{marginLeft:"30px"}}>
                        <Pagination
                            count={noOfPages}
                            page={page}
                            onChange={handlePageChange}
                            defaultPage={1}
                            //color="primary"
                            size="large"
                            showFirstButton
                            showLastButton
                            variant="outlined" 
                            shape="rounded" 
                        />
                        </div>
                    </Grid>
                </section>
            </main>
        </div>
    )
};
export default ReferralCases;